<template>
  <div>
    <BlockUI :message="msg" :url="uiBlockerImage" v-if="showBblockUi"></BlockUI>
    <div class="donation-area">
      <!-- <div v-html="webNotice"></div> -->
      <div v-html="webHeader"></div>
      <div class="page-title" style="background-image: url('static/assets/images/how-can-you-contribute.jpg');">
        <div class="container">
          <h1>HOW CAN YOU CONTRIBUTE?</h1>
        </div>
      </div>
      <div class="main donation" style="background-image: url('static/assets/images/tree-image.jpg');">
        <div class="container">
          <div class="row sec-padding1">
            <div class="col-md-12 content-column">
              <div class="content-inner">
                <div class="sec-title">
                  <h2>How can you contribute?</h2>
                </div>
              </div>
            </div>
          </div>
          <div class="row block-donation">
            <div class="col-lg-8 col-md-6 col-sm-12 content-column donation-content">
              <div class="content-inner">
                <div class="sec-heading">
                  <h2>We see a world full of<br>
                    Flourishing Youth with<br>
                    a Purposeful Life!
                  </h2>
                </div>
                <p class="text-dark">We dream to create a vibrant community
                    of social changemakers spread across India,
                    bringing positive change in various aspects of society.
                </p>
                <p class="text-dark">Donate to NIRMAN and be a part of this glorious vision!</p>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 donation-image">
              <img src="static/assets/images/donation-img.png" alt="Donation Image" class="img-fluid">
            </div>
          </div>
          <div class="donation-title-area d-flex align-items-center">
              <img src="static/assets/images/petals.png" class="img-leaf">
              <h2>Support the power of the youth</h2>             
          </div>
          <div class="donation-desc row">
            <div class="table-donate col-lg-8">
              <table class="table">
                <!-- <thead>
                  <tr>
                    <th>Amount</th>
                    <th>Description</th>
                  </tr>
                </thead> -->
                <tbody>
                  <tr>
                    <td>
                      <span>Rs 5,000</span>
                    </td>
                    <td>
                      Support the cost (lodging, boarding, training) of one participant for one NIRMAN Workshop.                    
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Rs 10,000</span>
                    </td>
                    <td>
                      Support the travel cost of a resource person for one NIRMAN Workshop.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Rs 15,000</span>
                    </td>
                    <td>
                      Support the cost (lodging, boarding, training) of one participant for the series of 3 NIRMAN Workshops.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Rs 25,000</span>
                    </td>
                    <td>
                      Support a month’s fellowship stipend for a young NIRMAN Fellow working full time for a social cause.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Rs 50,000</span>
                    </td>
                    <td>
                      Support the cost of various thought provoking books to be given as
                      educative gifts to all the participants from one NIRMAN Batch.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Rs 75,000</span>
                    </td>
                    <td>
                      Support the cost of conducting outreach and selection process for one NIRMAN Batch.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Rs 1,00,000</span>
                    </td>
                    <td>
                      Support the cost of 100 youth volunteers in Krutee NIRMAN action
                      learning activities across Maharashtra                    
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Rs 4,00,000</span>
                    </td>
                    <td>
                      Support the cost of one NIRMAN Workshop of 8 days for 60 budding social change-makers.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="table-donate-qr col-lg-4">
              <div class="img-holder">
                  <img src="static/assets/images/nirman-qr-code.jpg" alt="SEARCH NIRMAN QR Code" class="img-qr">
              </div>
            </div>
            <!-- <div class="row desc-holder">
                  <span>Rs 5,000</span>
                </div>
                <div class="col-md-9">
                  <p>Support the cost (lodging, boarding, training) of one participant for one NIRMAN workshop</p>
                </div>
            </div>
            <div class="row desc-holder">
                <div class="col-md-3">
                  <span>Rs 10,000</span>
                </div>
                <div class="col-md-9">
                  <p>Support the cost of a resource person for one NIRMAN workshop
</p>
                </div>
            </div> -->
          </div>
          <div class="donation-title-area d-flex align-items-center">
              <img src="static/assets/images/petals.png" class="img-leaf">
              <h2>Donate</h2>
          </div>        
          <div class="row clearfix">

            <div class="col-sm-6 col-md-8">
              <div clas="donation-title-info">
                <div class="donation-title-desc"><strong>Note:</strong> You can donate any amount to NIRMAN either from the above menu or any other amount you have in mind. We value each & every contribution. </div>
                <p>There are 4 ways you can make the transfer: </p>
                <ol class="donation-desc-list">
                  <li>Use the QR code on this page to make the payment.</li>
                  <li>Use the NIRMAN bank account details given besides and make an online transfer there.</li>
                  <li>Draw a cheque with the appropriate bank details and send it to us at NIRMAN, SEARCH, Gadchiroli - 442605, Maharashtra.</li>
                  <li>Use the following utility to fill in your details & click submit to take you to an online payments facility.</li>            
                </ol>
                  <p>Kindly use the method that suits you the best. In order to inform us that you have made the payment and to help us draw the appropriate receipt, we will highly appreciate it if you can send us an email or message at <a href="mailto:contact.nirman@gmail.com">contact.nirman@gmail.com</a> or <a href="tel:+918767680508">+91-8767680508</a> with your details. We will send you the receipt within 7 working days. Thanks again!</p>
                  <p>
                    Fill the following details & hit submit if you wish to use the online payments facility through this page. Else use the QR code or bank account details directly. 
                  </p>
              </div>
              <form class="donation-form" name="donation-form">
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <div class="form-group">
                        <input type="text" id="fname1"  name="fname1" placeholder="First Name*" v-model="donerInfo.firstName" v-validate="{ rules: { required: true } }" required>
                        <span class="text-danger" v-show="errors.has('fname1')">
                          <small>First Name should be valid</small>
                        </span>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div class="form-group">
                        <input type="text" id="lname1"  name="lname1" placeholder="Last Name*" v-model="donerInfo.lastName" v-validate="{ rules: { required: true } }" required>
                        <span class="text-danger" v-show="errors.has('lname1')">
                          <small>Last Name should be valid</small>
                        </span>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div class="form-group">
                        <div class="input-group">
                          <span class="input-group-addon" id="basic-addon1">+ 91</span>
                              <input type="text" placeholder="Mobile Number" aria-describedby="basic-addon1" v-model="donerInfo.mobileNo" inputmode="numeric" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" pattern="^[6-9]\d{9}$" minlength="10" maxlength="10" name="mobileNo" >
                              <span class="text-danger" v-show="errors.has('mobileNo')">
                            <small>Mobile Number should be valid</small>
                          </span>
                        </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div class="form-group">
                        <input type="email" id="email1" name="emailId" placeholder="Email" v-model="donerInfo.emailId" v-validate="'email'">
                        <!-- <span class="text-danger" v-show="errors.has('emailId')">
                          <small>Email Id should be valid</small>
                        </span> -->
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div class="form-group">
                        <input type="text" id="address" name="address" placeholder="Address*" required v-model="donerInfo.address">
                        <span class="text-danger" v-show="errors.has('address')">
                          <small> Put the valid Address </small>
                        </span>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div class="form-group">
                        <input type="text" id="pincode" name="pincode" placeholder="Pincode*" required v-model="donerInfo.pincode" maxlength="6" v-validate="'digits:6'">
                        <span class="text-danger" v-show="errors.has('pincode')">
                          <small>Please enter valid pincode </small>
                        </span>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div class="form-group">
                        <input type="text" id="panNumber" name="panNumber" placeholder="PAN Number" v-model="donerInfo.panNumber" v-validate="'alpha_num'" maxlength="10">
                        <!-- <span class="text-danger" v-show="errors.has('panNumber')">
                          <small>Please enter valid PAN number </small>
                        </span> -->
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div class="form-group">
                        <input type="text" id="comment1" name="comment1" placeholder="Comment" v-model="donerInfo.comment">
                    </div>
                  </div>
                </div>
                <div class="donation-sub-area">
                  <div class="row">
                    <div class="col-md-12">
                      <p><strong>Enter Donation Amount</strong> </p>
                    </div>
                  </div>
                  <div class="row donate-holder">
                    <div class="col-md-6">
                      <div class="form-group">
                        <input type="text" id="donation" name="donation" placeholder="Donation Amount (Rs.)" v-model="donerInfo.donationAmount">
                      </div>
                    </div>
                    <!-- <div class="col-md-6">
                      <select class="form-control" v-model="donerInfo.donationCause" required>
                        <option selected disabled value="">Select Donation Purpose</option>
                        <option>Support the cost (lodging, boarding, training) of one participant for one NIRMAN workshop</option>
                        <option>Support the cost of a resource person for one NIRMAN workshop</option>
                        <option>Cover the cost of reading material, books, journals, DVDs for the NIRMAN Library for one year</option>
                        <option>Support the cost of 20 medical volunteers from NIRMAN (MBBS/BAMS students) in the surgery workshops at SEARCH for the rural/tribal patients in Gadchiroli</option>
                        <option>Cover the traveling cost of five members of the NIRMAN Executive Team across Maharashtra for one year</option>
                        <option>Support an entire NIRMAN workshop of 8 days for 60 budding social change-makers</option>
                      </select>
                    </div> -->
                  </div>
                  <div class="row">
                    <div class="col-md-12 block-terms">
                      <label for='terms'>
                        <input type="checkbox" value="agree"  name="" id="agree" v-model="isTnCAccepted">
                        I agree to <a href="javascript:;" class="tc_space">Terms and Conditions.
                          <div class="tc_desc-area">
                              <span class="tc_desc">
                                <ul>
                                  <li>After successful payment within 15 days we will send you 80G receipt
                                    of payment on your provided email ID.
                                  </li>
                                  <li>Payments are processed through Atom technologies ltd, for more
                                    details visit- <a href="https://www.atomtech.in" target="_blank">https://www.atomtech.in</a></li>
                                  <li>
                                    Terms of Use are governed by the laws of the Republic of India. In all
                                    disputes arising out of or relating to the use of this web site or service by
                                    the user, consent and submission to the exclusive jurisdiction and venue of
                                    the Courts in Gadchiroli, Maharashtra.
                                  </li>
                                  <li>NIRMAN reserves the right to modify, amend or amend the amended policy at any time and in
                                    any manner as it may see fit in this disclaimer. Any changes or modifications will be posted on
                                    the site.
                                  </li>
                                </ul>
                              </span>
                          </div>
                          </a>
                          <!-- <a href="javascript:;" class="tc_space1">Cancellation & Other Policies.
                            <div class="tc_desc-area1">
                              <span class="tc_desc">
                                <ul>
                                  <li>Donations successfully processed through a payment gateway will not be returned. Please select
    the cause you want to support and the amount you want to contribute before donating. No
    amount will be deducted in case the transaction process fails. There is no small donation to help
    the underprivileged section of our society. By donating, you can cause someone happiness!
                                  </li>
                                  <li>
                                    While using the website, it shows that it knows that it can obtain information related to the
    user, including a confidential nature, to know the entire process of availing the service or
    becoming part of the SEARCH - NIRMAN. This information will be used by the SEARCH - NIRMAN
    for the purposes of collecting its internal data and will be kept confidential. The SEARCH -
    NIRMAN reserves the right to disclose personal information where it believes such disclosure is
    required by law to carry out the necessary. The user or visitors agrees that all information that
    the SEARCH - NIRMAN has or can obtain for use of the service or with the permission of the user.
                                  </li>
                                </ul>
                              </span>
                            </div>
                          </a> -->
                      </label>
                    </div>
                    <div class="col-md-4">
                      <button type="button" name="submit-form" :disabled="!isTnCAccepted" class="theme-btn btn-style-two" @click="saveEnquiryDetails">Submit</button>
                    </div>
                    <div class="col-md-12 block-condition">
                      <span>*All Donations are eligible for tax exemption under section 80G of the Income Tax Act</span>
                    </div>

                  </div>
                </div>
              </form>
              <!-- <div class="donation-desc">
                <p class="desc-title"><strong>Donation Information:-</strong></p>
                <div class="table-donate">
                  <table class="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>Amount</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <span>Rs 5,000</span>
                        </td>
                        <td>
                        Participant for one NIRMAN workshop
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>Rs 10,000</span>
                        </td>
                        <td>
                          Support the cost of a resource person for one NIRMAN workshop
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>Rs 20,000</span>
                        </td>
                        <td>
                          Cover the cost of reading material, books, journals, DVDs for the NIRMAN Library for one year
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>Rs 50,000</span>
                        </td>
                        <td>
                          Support the cost of 20 medical volunteers from NIRMAN (MBBS/BAMS students) in the surgery workshops at SEARCH
                          for the rural/tribal patients in Gadchiroli
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>Rs 75,000</span>
                        </td>
                        <td>
                          Cover the traveling cost of five members of the NIRMAN Executive Team across Maharashtra for one year
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>Rs 4 Lakhs</span>
                        </td>
                        <td>
                          Support an entire NIRMAN workshop of 8 days for 60 budding social change-makers
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div> -->
            </div>
            <div class="col-sm-6 col-md-4 donation-info">
              <h4 class="donation-title">Account Details for Offline Donation</h4>
              <p>  Account title - SEARCH-NIRMAN<br>
                  Bank Name - Bank of Maharashtra <br>
                  Branch - Gadchiroli <br>
                  Account No. - 60011788671  <br>
                  IFS code - MAHB0000940</p>
            </div>
          </div>
        </div>
      </div>      
      <div v-html="webFooter"></div>
      <!-- <div class="footer">
        <div class="container">
          <div class="copyright">
           Copyright 2021 <span>NIRMAN</span> All rights reserved. <a href="https://nirman.mkcl.org/">Privacy Policy</a>
          </div>
        </div>
      </div> -->

    </div>
    <form :action=url method="POST" id="upsForm" name="upsForm">
        <input name="upsString" v-model="upsString" type="hidden" id="someId">
        <input name="reqFrom" value="goLang" type="hidden">
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import { PAYMENT_REQUEST_URL, FOOTER_APP, HEADER_APP } from "@/components/common/constants";
export default {
name:'donationData',
  components: {
  },
  data() {
    return {
      webNotice: '',
      webHeader: '',
      webFooter: '',
      donerInfo: {
        name: '',
        mobileNo: '',
        emailId: '',
        donationCause: '',
        panNumber: '',
        comment: '',
        address: '',
        donationAmount: ''
      },
      isFileUploaded: false,
      isSuccess: false,
      upsString: '',
      url: PAYMENT_REQUEST_URL,
      showBblockUi: false,
      uiBlockerImage: "static/assets/images/Spinner.svg",
      msg:'',
      isTnCAccepted: true
    }
  },
  methods: {
    validateInput () {
      // console.log('validateInput called');
      if (!this.donerInfo.firstName) {
        this.$toasted.error('Please enter first name')
        return false;
      }
      if (!this.donerInfo.lastName) {
        this.$toasted.error('Please enter last name')
        return false;
      }
      /* if (!this.donerInfo.emailId) {
        this.$toasted.error('Please enter valid emailId')
        return false;
      } */
      if (!this.donerInfo.mobileNo) {
        this.$toasted.error('Please enter valid mobile number')
        return false;
      }
      if (!this.donerInfo.address) {
        this.$toasted.error('Please enter valid address')
        return false;
      }
      if (!this.donerInfo.pincode || isNaN(this.donerInfo.pincode)) {
        this.$toasted.error('Please enter valid pincode')
        return false;
      }
      if (!this.donerInfo.donationAmount || isNaN(this.donerInfo.donationAmount) || parseFloat(this.donerInfo.donationAmount) <= 0) {
        this.$toasted.error('Please enter valid donation amount')
        return false;
      }
       /* if (!this.donerInfo.donationCause || this.donerInfo.donationCause === '') {
        this.$toasted.error('Please select donation cause')
        return false;
      } */
      if (!this.isTnCAccepted) {
        this.$toasted.error('Please accept Terms & conditions')
        return false;
      }
      this.$validator.validateAll()
      if (this.errors.any()) {
          this.$toasted.error('Please provide valid details...')
          return false;
      }
      return true;
    },
    saveEnquiryDetails() {
      var validationResponse = this.validateInput ()
      if (validationResponse === false) {
        return;
      }
        this.$swal({
          title: "Payment Confirmation",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#9cc327",
          confirmButtonText: "Yes, Proceed",
          html: '<h5>Are you sure? You are about to pay Rs. ' + this.donerInfo.donationAmount + ' to NIRMAN</h5>',
          // customClass: {
          //   confirmButton: 'theme-btn'
          // }
      }).then(action => {
        // console.log(action.value);
        if (action.value) {
          this.msg = 'Saving donor information.. Please wait'
          this.showBblockUi = true
          return new Promise((resolve, reject) => {
            this.donerInfo.donationAmount = parseFloat(this.donerInfo.donationAmount)
              axios.post('/o/paymentRequest', this.donerInfo).then((result) => {
                if (result.status === 200) {
                  this.upsString = result.data.upsString
                  // console.log('this.upsString >> ' + this.upsString)
                  this.msg = 'Redirecting you to Payment Gateway...'
                  this.submitUpsForm()
                  resolve(true)
                }
              }).catch((err) => {
                console.log(err)
                 this.showBblockUi = false;
                this.$toasted.error('Error occured while saving data...')
                reject(err)
              });
          })
        } else {
          return false;
        }
      });
    },
    submitUpsForm () {
      document.getElementById('someId').value = this.upsString
      document.getElementById('upsForm').submit()
    },
    dropList() {
      var x = document.getElementsByClassName('main-menu')[0].getElementsByClassName('dropdown');
      for (var i = 0; i < x.length; i++) {
        x[i].innerHTML += '<div class="dropdown-btn"><span class="fa fa-angle-down"></span></div>';
      }

      var nvt = document.getElementsByClassName('navbar-toggle');
      var nvc = document.getElementsByClassName('navbar-collapse');
      nvt[0].addEventListener('click', function() {
        nvc[0].classList.toggle('in');
      });

      var z = document.querySelectorAll('.main-menu .dropdown > a');
      for (var i = 0; i < z.length; i++) {
        z[i].addEventListener('click', function(e) {
          e.preventDefault();
        });
      }

      //Dropdown BTn
      var y = document.getElementsByClassName('dropdown-btn');
      for (var i = 0; i < y.length; i++) {
        y[i].addEventListener('click', function() {
          this.previousElementSibling.classList.toggle('show');          
        });
      }     
    }
  },
   created: function () {
  },
  mounted: function () {

    // var iframeWin = parent.document.getElementById("header-frame");
    // iframeWin.height = document.body.scrollHeight;
    // console.log(iframeWin.height);
    // var iframe = window.parent.document.getElementById('header-frame');
    
    // console.log(iframe)

    //AXIOS
    // axios
    //   .get('http://localhost/projects/Grav/nirman/nirman/footer-app')
    //   .then(response => (this.webFooter = response.data))
    // axios
    //   .get('http://localhost/projects/Grav/nirman/nirman/header-app')
    //   .then(response => (this.webHeader = response.data))
    
    //   var it = document.getElementsByClassName("navbar-toggle");
    //   var t1 = document.getElementsByClassName("navbar-collapse");
    //   for(var i = 0; i < it.length; ++i){
    //     it[i].onclick = function() {
    //         t1.classList.add("in");
    //         this.classList.remove("in");
    //     }
    //   }
    //  axios
    //   .get(NOTICE_APP)
    //   //.get('FOOTER_APP')
    //   //.get('http://stagingnirman.mkcl.org/notice-app')
    //   //.get('FOOTER_APP')
    //   //.get('http://stagingnirman.mkcl.org/notice-app')
    //   // .then(response => (this.webFooter = response.data))
    //   .then((response) => {
    //     // console.log(response.data)
    //     this.webNotice = response.data
    //     // this.$nextTick(() => {
    //     //   this.dropList();
    //     // })
    //     // var d = document.getElementById('footer');
    //     // d.classList.add('my-class');
    //   })

    //----------------------------
    //      Header
    //----------------------------
    axios
      .get(HEADER_APP)
      //.get('HEADER_APP')
     // .get('http://stagingnirman.mkcl.org/header-app')
      // .then(response => (this.webFooter = response.data))
      .then((response) => {
        // console.log(response.data)
        this.webHeader = response.data
        this.$nextTick(() => {
          this.dropList();
        })
        // var d = document.getElementById('footer');
        // d.classList.add('my-class');
      })

      //----------------------------
      //      Header
      //----------------------------
    axios
      .get(FOOTER_APP)
      //.get('FOOTER_APP')
      //.get('http://stagingnirman.mkcl.org/footer-app')
      //.get('FOOTER_APP')
      //.get('http://stagingnirman.mkcl.org/footer-app')
      // .then(response => (this.webFooter = response.data))
      .then((response) => {
        // console.log(response.data)
        this.webFooter = response.data
        // this.$nextTick(() => {
        //   this.dropList();
        // })
        // var d = document.getElementById('footer');
        // d.classList.add('my-class');
      })
   

  }
}
</script>




// WEBPACK FOOTER //
// donationData.vue?25298ae2